<!--
 * @FileDescription: 地图数据组件
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-08-22 15:51:14
 -->
<template>
  <div class="map-bg-template">
    <div class="map-container" id="map"></div>
    <canvas id="deck" ref="deckMap"></canvas>
    <div class="feature-descibe" v-if="describeShow">{{ searchSciPos }}</div>
    <!-- <div class="roll-back" @click="rollBackView"></div> -->
  </div>
</template>

<script>
export default {
  name: 'MapTemplate',
}
</script>

<script setup>
import { defineProps, onMounted, defineEmits, ref } from 'vue';
// import { BorderBox12 as DvBorderBox12 } from '@kjgl77/datav-vue3';
// import { BorderBox10 as DvBorderBox10 } from '@kjgl77/datav-vue3';
// import { BorderBox11 as DvBorderBox11 } from '@kjgl77/datav-vue3';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
// import { Deck, FlyToInterpolator } from '@deck.gl/core/typed';
import { Deck } from '@deck.gl/core/typed';
import { ArcLayer } from '@deck.gl/layers'
// import { geoData } from './geoData'
// import activeJson from "@/components/activeChartData.json"
// import activeJson from "/public/activeChartData.json"
// import axios from 'axios';



let props = defineProps({
  order: String,
});
console.log(props)

let viewState = {
  latitude: 32.307,
  longitude: 120.157,
  zoom: 7.8,
  pitch: 62.89,
  bearing: -7.20
};
// const order = props.order;

// function sleep(ms) {
//   return new Promise(resolve => setTimeout(resolve, ms));
// }

let tick = 0;

const emit = defineEmits(['clickScience']);

let describeShow = ref(false);

let searchSciPos = ref("")

// let activeJson=ref({})

// let rollBackView = null;

//大弧度
const deckMap = ref();
const nnuPos = [118.9126, 32.1002];
let currentDataIndex = 0;
let dataNameList = ["firChange", "secChange", "thiChange"]

const mapColor = (stColor, endColor, pos) => {
  if (pos > 0.8) {
    return [249, 56, 40, 250]
  } else if (pos > 0.5) {
    return [250, 117, 90, 250]
  } else if (pos > 0.2) {
    return [247, 130, 27, 250]
  } else {
    let posPos = Math.exp(pos / 0.2) / Math.E
    const stBlue = [187, 232, 242, 240]
    const endBlue = [25, 75, 224, 240]
    return [
      (endBlue[0] - stBlue[0]) * posPos + stBlue[0],
      (endBlue[1] - stBlue[1]) * posPos + stBlue[1],
      (endBlue[2] - stBlue[2]) * posPos + stBlue[2],
      (endBlue[3] - stBlue[3]) * posPos + stBlue[3],
    ]
  }
}

const mapColor2 = (stColor, endColor, pos) => {
  if (pos > 0.8) {
    return [255, 151, 37, 250]
  }
  else if (pos > 0.5) {
    return [242, 183, 5, 250]
  }
  else if (pos > 0.2) {
    return [201, 235, 249, 250]
  }
  else {
    let posPos = Math.exp(pos / 0.2) / Math.E
    const stBlue = [182, 220, 239, 240]
    const endBlue = [3, 76, 140, 240]
    return [
      (endBlue[0] - stBlue[0]) * posPos + stBlue[0],
      (endBlue[1] - stBlue[1]) * posPos + stBlue[1],
      (endBlue[2] - stBlue[2]) * posPos + stBlue[2],
      (endBlue[3] - stBlue[3]) * posPos + stBlue[3],
    ]
  }
}

const mapData2Color = (data, max, min, stColor, endColor) => {
  const wholeInterval = max - min;
  let dataPos = (data - min) / wholeInterval;
  return mapColor(stColor, endColor, dataPos);
}

const mapData2Color2 = (data, max, min, stColor, endColor) => {
  const wholeInterval = max - min;
  let dataPos = (data - min) / wholeInterval;
  return mapColor2(stColor, endColor, dataPos);
}

const ScreenBaseRatio =  () => {
    let clientWidth = window.innerWidth || document.documentElement.clientWidth;
    let clientHeight = window.innerHeight || document.documentElement.innerHeight;
    let widthRatio = clientWidth / 2560;
    let heightRatio = clientHeight / 1440;

    let screenRatio = widthRatio * 0.8 + heightRatio * 0.2;

    return screenRatio;
}
let screenRatio = ScreenBaseRatio();

const mapData2Width = (data, max, min, stWidth, endWidth) => {
  const wholeInterval = max - min;
  let dataPos = (data - min) / wholeInterval;
  dataPos = Math.exp(dataPos) / Math.E;
  return ((endWidth - stWidth) * dataPos + stWidth)*screenRatio
}

let isHovering = false;

// let currentSciPtId = 0;

onMounted(() => {
  // axios.get('/activeChartData.json')
  //   .then(response => {
  //     activeJson.value = response.data;
  //   })
  //   .catch(error => {
  //     console.log(error);
  //   });
  const map = new mapboxgl.Map({
    accessToken: 'pk.eyJ1Ijoiam9obm55dCIsImEiOiJja2xxNXplNjYwNnhzMm5uYTJtdHVlbTByIn0.f1GfZbFLWjiEayI6hb_Qvg',    //tzh  
    // accessToken: 'pk.eyJ1IjoiMTM0NzczNTgxNzMiLCJhIjoiY2xsbHpsbGc0MWxqYTNwcXVxY3l5Mjk0bCJ9.cBfmWUjcqLeqBWZMZROR2Q',   //dcq
    container: 'map',
    interactive: true,
    // style: 'mapbox://styles/13477358173/clk34oxxi004m01rj8glker08',  //底图没有点
    style: 'mapbox://styles/johnnyt/clhc1h1ow013q01qy6wz7bdu7',  //底图有点
    zoom: viewState.zoom,
    center: [viewState.longitude, viewState.latitude],
    pitch: viewState.pitch,
    bearing: viewState.bearing
  });

  // rollBackView = () => {
  //   map.flyTo({
  //     zoom: viewState.zoom,
  //     center: [viewState.longitude, viewState.latitude],
  //     pitch: viewState.pitch,
  //     bearing: viewState.bearing
  //   }, 500);
  //   if (describeShow.value) {
  //     describeShow.value = false;
  //   }
  // }

  if (deckMap.value == null) {
    return;
  }

  // fetch("http://223.2.9.189:8080/activeChartData.json")
  fetch("/activeChartData.json")
    .then(function (response) {
      // 如果请求成功
      if (response.ok) {
        // 解析 JSON 数据
        return response.json();
      } else {
        throw new Error("无法加载 JSON 文件");
      }
    })
    .then(function (activeJson) {
      const changeWorkData = () => {
        currentDataIndex = (currentDataIndex + 1) % (dataNameList.length);
        // console.log("change data", currentDataIndex)
        renderLayer();
      }


      const renderLayer = () => {
        // console.log(activeJson.searchSciPt.features);
        const workFlowLayer = new ArcLayer({
          id: 'workFlowArc',
          data: activeJson.searchSciPt.features,
          getSourcePosition: nnuPos,
          getTargetPosition: d => d.geometry.coordinates,
          getSourceColor: d => {
            return mapData2Color(d.properties[dataNameList[currentDataIndex]], 55, 0, [57, 132, 230, 200], [229, 70, 53, 200])
          },
          getTargetColor: d => {
            return mapData2Color2(d.properties[dataNameList[currentDataIndex]], 55, 0, [57, 132, 230, 200], [229, 70, 53, 200]);
          },
          getWidth: d => {
            let width = mapData2Width(d.properties[dataNameList[currentDataIndex]], 55, 0, 0, 8);
            // console.log('width', width)
            return width
          },
          // if need to update
          updateTriggers: {
            getSourceColor: [currentDataIndex],
            getTargetColor: [currentDataIndex],
            getWidth: [currentDataIndex]
          }
        })
        deck.setProps({
          layers: [workFlowLayer],
        })

      }

      const deck = new Deck({
        canvas: 'deck',
        width: "100%",
        height: "100%",
        initialViewState: viewState,
        controller: true,
        onViewStateChange: ({ viewState }) => {
          map.jumpTo({
            center: [viewState.longitude, viewState.latitude],
            zoom: viewState.zoom,
            bearing: viewState.bearing,
            pitch: viewState.pitch
          });
          renderLayer();
        },
        onLoad: () => {
          // dynamic change data
          setInterval(changeWorkData, 1000);

        },
        // onHover: (info, event) => {
        //   let features = map.queryRenderedFeatures(
        //     [new mapboxgl.Point(info.x - 20, info.y + 20), new mapboxgl.Point(info.x + 20, info.y - 20)],
        //     { layers: ['searchscipt'] }
        //   )
        //   if (features.length > 0) {
        //     console.log(features)
        //     map.getCanvas().style.cursor = 'pointer';
        //   }
        //   else {
        //     map.getCanvas().style.cursor = '';
        //   }
        // },
        // onClick: (info, event) => {
        //   // console.log(info.x, info.y)
        //   let features = map.queryRenderedFeatures(
        //     [new mapboxgl.Point(info.x - 20, info.y + 20), new mapboxgl.Point(info.x + 20, info.y - 20)],
        //     { layers: ['searchscipt'] }
        //   )
        //   if (features.length > 0) {
        //     console.log(features)
        //     emit("clickScience", features[0].properties.id)
        //   }

        // }
      })

      map.on('load', () => {
        setInterval(() => {
          // console.log(tick)
          map.setPaintProperty('searchscipt', 'circle-blur', 0.5 + tick / 20);
          tick = (tick + 1.0) % 10;
        }, 100);

        map.addSource('searchsciarea', {
          type: 'geojson',
          data: activeJson.searchSciPt
        });
        map.addLayer({
          id: 'searchscipt',
          type: 'circle',
          source: 'searchsciarea',
          paint: {
            "circle-stroke-width": 1,
            "circle-blur": [
              "match",
              [
                "get",
                "construct"
              ],
              [
                1
              ],
              0.4,
              0
            ],
            "circle-color": "rgb(130, 227, 223)",
            "circle-opacity": 0.75,
            "circle-radius": [
              "interpolate",
              [
                "linear"
              ],
              [
                "zoom"
              ],
              0,
              5,
              4.69,
              5,
              5.88,
              8,
              16.17,
              10,
              22,
              5
            ],
            "circle-stroke-opacity": 0.5,
            "circle-stroke-color": "rgb(0, 42, 102)"
          }
        });
        map.addLayer({
          id: 'searchscilabel',
          type: 'symbol',
          source: 'searchsciarea',
          paint: {
            "text-color": "rgb(231, 251, 254)",
            "text-opacity": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              0,
              7.94,
              0.9,
              8,
              0.9,
              22,
              1
            ]
          },
          layout: {
            "text-field": ["to-string", ["get", "name"]],
            "text-anchor": "bottom",
            "text-offset": [0, 3],
            "text-font": ["YRDZST Heavy", "Arial Unicode MS Regular"],
            "text-size": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              16,
              6,
              16,
              12.85,
              24,
              22,
              32
            ],
            // "text-variable-anchor": [
            //   "bottom",
            //   // "top",
            //   // "top-right",
            //   // "bottom-left",
            //   // "right",
            //   // "left",
            //   // "bottom-right",
            //   // "top-left"
            // ]
          }
        });

        deck.setProps({
          onHover: (info, event) => {
            let features = map.queryRenderedFeatures(
              [new mapboxgl.Point(info.x - 20, info.y + 20), new mapboxgl.Point(info.x + 20, info.y - 20)],
              { layers: ['searchscipt', 'searchscilabel'] }
            )
            if (features.length > 0) {
              // console.log(features)
              isHovering = true;
            }
            else {
              isHovering = false;
            }
          },
          onClick: (info, event) => {
            // console.log(info.x, info.y)
            let features = map.queryRenderedFeatures(
              [new mapboxgl.Point(info.x - 20, info.y + 20), new mapboxgl.Point(info.x + 20, info.y - 20)],
              { layers: ['searchscipt', 'searchscilabel'] }
            )
            if (features.length > 0) {
              // console.log(features)
              emit("clickScience", features[0].properties.id)
            }

          },
          getCursor: ({isDragging}) => (isDragging ? 'grabbing' : (isHovering ? 'pointer' : 'grab'))
        })

        // map.on('mouseenter', 'searchscipt', () => {
        //   map.getCanvas().style.cursor = 'pointer';
        // })

        // map.on('mouseleave', 'searchscipt', () => {
        //   map.getCanvas().style.cursor = '';
        // })

        // setInterval(() => {
        //   if(currentSciPtId == geoData['searchSciPt']["features"].length) {
        //     console.log("origin.")
        //     deck.setProps({
        //       initialViewState: {
        //         latitude: viewState.latitude,
        //         longitude: viewState.longitude,
        //         zoom: viewState.zoom,
        //         pitch: viewState.pitch,
        //         bearing: viewState.bearing,
        //         transitionDuration: 3000,
        //         transitionInterpolator: new FlyToInterpolator({speed:1.3})
        //       }
        //     })
        //     map.flyTo({
        //       center:[viewState.longitude,viewState.latitude],
        //       zoom:viewState.zoom,
        //       bearing:viewState.bearing,
        //       pitch:viewState.pitch
        //     }, 3000);
        //     currentSciPtId = 0
        //   }
        //   else {
        //     currentSciPtId += 1;
        //     emit("clickScience", currentSciPtId)
        //     deck.setProps({
        //       initialViewState: {
        //         latitude: geoData['searchSciPt']["features"][currentSciPtId-1].geometry.coordinates[1],
        //         longitude: geoData['searchSciPt']["features"][currentSciPtId-1].geometry.coordinates[0],
        //         zoom: 12.42,
        //         pitch: 62.89,
        //         bearing: -7.20,
        //         transitionDuration: 3000,
        //         transitionInterpolator: new FlyToInterpolator({speed:1.3})
        //       }
        //     })
        //     map.flyTo({
        //       center: [geoData['searchSciPt']["features"][currentSciPtId-1].geometry.coordinates[0], geoData['searchSciPt']["features"][currentSciPtId-1].geometry.coordinates[1]],
        //       zoom: 12.42,
        //       pitch: 62.89,
        //       bearing: -7.20
        //     }, 3000)
        //   }

        //   }, 10000);
      })

    })
    .catch(function (error) {
      console.log(error.message);
    });



})

</script>


<style lang="scss" scoped>
$orders: 1, 2, 3, 4, 5, 6, 7, 8;

div.map-bg-template {
  position: absolute;
  // margin-top: 1vh;
  // margin-bottom: 1vh;
  width: 100vw;
  height: 84vh;
  // pointer-events:none;
  border: none;

  @each $order in $orders {
    &[order='#{$order}'] {
      order: $order;
    }
  }

  #deck {
    position: absolute;
    // pointer-events:none;
    // top: 0.5%;
    // left: 0.5%;
    width: 100%;
    height: 100;
    border-radius: 8px;
    z-index: 6;
  }

  div.map-container {
    position: absolute;
    // top: 0.4%;
    // left: 0.2%;
    width: 100%;
    height: 100%;
    z-index: 5;
    border-radius: 8px;
    overflow: hidden;
  }

  div.feature-descibe {
    position: absolute;
    right: 29vw;
    top: 2vh;
    width: fit-content;
    height: 5vh;
    padding-left: 1vw;
    padding-right: 1vw;
    text-align: center;
    font-size: 2vh;
    border-radius: 3px;
    backdrop-filter: blur(3px);
    line-height: 5vh;
    z-index: 20;
    color: rgb(235, 255, 251);
    background-color: rgba(0, 128, 255, 0.5);
  }

  div.roll-back {
    position: absolute;
    width: 2vw;
    height: 2vw;
    right: 1vw;
    bottom: 4vh;
    z-index: 21;
    // background-color: aqua;
    background-image: url("http://223.2.9.189:8080/image/zoom-in.png");
    background-size: cover;
    transition: all 0.5s ease-in-out;

    &:hover {
      width: 2.5vw;
      height: 2.5vw;
      cursor: pointer;
    }
  }

}
</style>
